/**
 * Copyright Mántum All Rights Reserved.
 */
import { nanoid } from 'nanoid';

export default (): string => nanoid();

export const encode = (value: string) => window.btoa(value);
